import client from '../../../../lib/client';

import { ENDPOINT } from '../constants';

const isBlank = (value) =>
  value === undefined || value === null || value === '';

/** Buang filter kosong supaya server tidak menerima `search=` dsb. */
function compactParams(params = {}) {
  return Object.fromEntries(
    Object.entries(params).filter(([, value]) => !isBlank(value)),
  );
}

/**
 * @param {{status?: string, search?: string, idRombel?: string,
 *   start?: string, end?: string, page?: number, limit?: number}} params
 */
export function getStudentLeaveRequests(params) {
  return client.get(ENDPOINT, { params: compactParams(params) });
}

export function getStudentLeavePendingCount() {
  return client.get(`${ENDPOINT}/pending-count`);
}

/**
 * @param {string} id
 * @param {{status: 'approved'|'rejected', approvalNote?: string}} payload
 */
export function decideStudentLeaveRequest(id, payload) {
  return client.put(`${ENDPOINT}/${id}/decision`, payload);
}
